module.exports = __webpack_public_path__ + "img/Jason Redmond.be395def.png";